import { useEffect, ReactNode } from 'react';
import browser from '@openclassrooms/utils/browser';
import { scrollToElement } from '@openclassrooms/ui-web/scroll';

interface Props {
  children: ReactNode;
  selector: string;
}

const ScrollTo = ({ children, selector }: Props) => {
  useEffect(() => {
    if (!selector) {
      return;
    }
    try {
      const element = browser.document.querySelector(selector);
      if (element) {
        scrollToElement(element);
      }
    } catch (error) {
      // Do nothing if selector is not valid (this is not necessary an error)
    }
  }, [selector]);

  return children;
};

export default ScrollTo;
